import { POST } from '@/api'
import edit from './edit'

const INITIAL_VISIT = {
  id: null,
  rsvId: null,
  date: null,
  storeId: null,
  store: null,
  time: null,
  persons: null,
  table: [],
  course: [],
  medium: null,
  settlement: null,
  remarks: null,
  ordersExistence: false,
  cancelWithoutNotice: false,
  visitStatus: null,
  options: null,
}

export default {
  namespaced: true,
  state: {
    list: [],
    next: 0,
    busy: false,
  },
  modules: {
    edit,
  },
  mutations: {
    clear(state) {
      state.list = []
      state.next = 0
    },
    add(state, { visits, next }) {
      state.list = state.list.concat(visits.map(visit => ({ ...INITIAL_VISIT, ...visit })))
      state.next = next
    },
    remove(state, id) {
      state.list = state.list.filter(visit => visit.id !== id)
      if (state.next !== null) state.next = state.list.length
    },
    busy(state, busy) {
      state.busy = busy
    },
    end(state) {
      state.next = null
    },
  },
  actions: {
    async get(store, id) {
      const { commit, state } = store

      commit('busy', true)

      const { status, message, data } = await POST('/api/web/customer/visit_history', {
        id,
        start: state.next,
        limit: 10,
      })

      if (status === 200) {
        const { pagenation, history: visits } = data.visitHistory
        commit('add', {
          visits: visits.map(({ option, ...visit }) => ({
            ...visit,
            id: option ? option.id : null,
            options: option
              ? (option.values || []).reduce((options, o) => Object.assign(options, { [o.id]: o.value }), {})
              : null,
          })),
          next: pagenation.next,
        })
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
    },
    async remove(store, historyId) {
      const { commit, state } = store
      if (state.busy) return false
      commit('busy', true)

      const { status, message } = await POST('/api/web/customer/visit_history/delete', { historyId })

      if (status === 200) {
        commit('remove', historyId)
      } else {
        commit('app/error', { status, message }, { root: true })
      }

      commit('busy', false)
      return status === 200
    },
  },
}
